import React, { FunctionComponent, useEffect } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { compose } from 'redux';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import {
    BottomBubble,
    FlashMessage,
    Recommendations,
    Spinner
} from '@client/components/shared/Shared';
import { buildUrlForRouteLoadingError } from '@client/components/shared/Helpers';
import SecondarySubscriptionContainerSlick from '@client/components/shared/SecondarySubscription/SecondarySubscription';
import {
    TRACK_RECO_CAMPAIGN_OVERVIEW,
    RECO_ITEM_WIDTH
} from '@client/config/constants';
import { isXsScreen } from '@client/helpers/screens';
import { SectionTitle } from '@client/components/shared/Shared';
import Banner from './banner/banner';
import Grid from './campaigns/Grid';
import MobileCampaigns from './campaigns/mobileCampaigns/MobileCampaigns';
import UpcomingSection from './campaigns/UpcomingSection';
import HiddenCampaign from './HiddenCampaign';
import styles from './MyLoungeWrapper.scss';

interface Props {
    routeLoading: boolean;
    mylounge: any;
    clientDevice: any;
    params?: object;
    flashMessage?: any;
    location?: object;
    routeLoadingErrors: any;
}

export const MyLoungeWrapper: FunctionComponent<Props> = (
    {
        mylounge,
        location,
        params,
        routeLoading,
        flashMessage,
        clientDevice,
        routeLoadingErrors
    },
    { router }
) => {
    useEffect(() => {
        if (routeLoadingErrors) {
            router.push(
                buildUrlForRouteLoadingError(
                    routeLoadingErrors,
                    router.getCurrentLocation()
                )
            );
        }
    }, [routeLoadingErrors]);

    if (!mylounge) {
        return null;
    }

    const { hiddenCampaign } = mylounge;

    const { width, height } = clientDevice || {};

    if (routeLoading) {
        return (
            <section styleName="wrapper-loader">
                <div styleName="spinner">
                    <Spinner black={true} />
                </div>
            </section>
        );
    }
    const xsScreen = isXsScreen(width);

    // to avoid events firing twice, the second <Grid /> component receives a no-op function for resize handler
    return (
        <TranslationsScope path="myLounge">
            <div styleName="outer-wrapper">
                <Banner />
                <SecondarySubscriptionContainerSlick />
                <section styleName="wrapper">
                    {flashMessage
                        ? flashMessage.flashMessages.map((message: any) => (
                              <FlashMessage
                                  type={message.type}
                                  text={message.text}
                              />
                          ))
                        : null}
                    {xsScreen && hiddenCampaign && (
                        <div styleName="hidden-campaign">
                            <HiddenCampaign campaign={hiddenCampaign} />
                        </div>
                    )}
                    {xsScreen ? (
                        <MobileCampaigns
                            id="open"
                            width={width}
                            height={height}
                            params={params}
                            myloungeData={mylounge.open}
                            location={location}
                        />
                    ) : (
                        <Grid
                            id="open"
                            width={width}
                            params={params}
                            campaigns={mylounge.open}
                            hiddenCampaign={hiddenCampaign}
                            location={location}
                        />
                    )}
                    <SectionTitle message="recommendations.sectionTitle" />
                    <Recommendations
                        recommendations={mylounge.recommendation}
                        width={width}
                        itemWidth={RECO_ITEM_WIDTH}
                        source={TRACK_RECO_CAMPAIGN_OVERVIEW}
                    />
                    <UpcomingSection
                        location={location}
                        params={params}
                        hasTitle
                    />
                </section>
                <BottomBubble />
            </div>
        </TranslationsScope>
    );
};

MyLoungeWrapper.contextTypes = {
    router: PropTypes.object
};

export default compose(CSSModules(styles, { allowMultiple: true }))(
    MyLoungeWrapper
);
